export default class GrilleCountComponentController {
	static $inject = ['GrilleTarifairesService'];

	GrilleTarifairesService: any;
	count: number = 0;
	hasErrorGrilleCourante: boolean = false;
	loading: boolean = true;
	domaine: string;
	id: number;
	refreshKey: any;

	constructor(GrilleTarifairesService: any) {
		this.GrilleTarifairesService = GrilleTarifairesService;
	}

	async $onInit() {
		await this.getGrilleCount();
	}

	$onChanges(changes: any) {
		if (changes.refreshKey && !changes.refreshKey.isFirstChange()) {
			this.refreshCount();
		}
	}

	async getGrilleCount() {
		this.startLoading();
		try {
			const data = await this.GrilleTarifairesService.getGrilleCountAndErrors(this.domaine, this.id);
			this.count = data.count;
			this.hasErrorGrilleCourante = data.hasErrorGrilleCourante;
		} catch (error) {
			console.error('Error getting grille count:', error);
		} finally {
			this.stopLoading();
		}
	}

	get hasErrors(): boolean {
		return this.hasErrorGrilleCourante;
	}

	async refreshCount() {
		await this.getGrilleCount();
	}

	startLoading() {
		this.loading = true;
	}

	stopLoading() {
		this.loading = false;
	}
}
